import { convertLength } from '@mui/material/styles/cssUtils';
import React, {useState, useEffect, useRef} from 'react'
import { Circle, Group, Image, Rect, Text, Transformer } from 'react-konva'
import { Html } from 'react-konva-utils';
import AgregarNodo from '../../Functions/AgregarNodo';

import ModalEditTool from '../Alertas/ModalEditTool';
import PanelHerramientas from '../Lienzo/PanelHerramientas';
import ImagenURL from './ImagenURL';
import TextoEditable from './TextoEditable';



const NodoComponent = (props) => {
    const {id, x, y, color, 
        isDragging, 
        nodos, 
        setNodos, 
        lineas,
        setLineas,
        isSelected,
        onSelect,
        onChange, 
        shapeProps, 
        text,
        width,
        height,
        fontSize,
        align,
        fontStyle,
        verticalAlign,
        contorno,
        strokeWidth,
        textFill,
        fill,
        urlImagen,
        imgWidth,
        imgHeight,
        imgId,
        tieneImagen,
        historial,
        setHistorial,
        historyStep,
        setHistoryStep,
    } = props;
    
    const shapeRef = useRef();
    const trRef = useRef();
    
    const [isEditing, setIsEditing] = useState(false);
    const [textValue, setTextValue] = useState(text);
    
    
    const [mostrarColor, setMostrarColor] = useState(false);
    const [abrirModal, setAbrirModal] = useState(false);
    const handleClose = () => setAbrirModal(false);

    const [mostrarImagen, setMostrarImagen] = useState(false);
    
    
    useEffect(() => {
        if (isSelected) {
          // we need to attach transformer manually
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [isSelected, historial]);

    const handleDragStart = (e) =>{
        const id = e.target.attrs.id;

        setNodos(
            nodos.map((nodo)=>{
                return {
                    ...nodo,
                    isDragging: nodo.id === id,
                }
            })
        )
    }

    const handleDragEnd = (e) =>{
        const historialAux = historial.slice(0, historyStep+1) 
        setHistorial(historialAux);
        const id = e.target.attrs.id;

        setNodos(
            nodos.map((nodo)=>{
                // console.log(rect);
                if(id === nodo.id){
                    return {
                        ...nodo,
                        isDragging: false,
                        x: e.target.attrs.x,
                        y: e.target.attrs.y
                    }
                }else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
                
            }) 
        )
        
        lineas.map((line)=>{
            let listaPuntos = line.vertices;
            if(line.rectangulosLinea.includes(id)){
                if(line.rectangulosLinea[0]===id){
                    listaPuntos[0] = e.target.attrs.x+width/2;
                    listaPuntos[1] = e.target.attrs.y+height/2;
                }else{
                    listaPuntos[2] = e.target.attrs.x+width/2;
                    listaPuntos[3] = e.target.attrs.y+height/2;
                }
            }
        })
        
    }

    const handleMove = (e) =>{
        // console.log(idCuadradoSeleccionado);
        const id = e.target.attrs.id;
        setNodos(
            nodos.map((nodo)=>{
                // console.log(rect);
                if(id === nodo.id){
                    return {
                        ...nodo,
                        isDragging: false,
                        x: e.target.attrs.x,
                        y: e.target.attrs.y
                    }
                }else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
                
            }) 
        )

        lineas.map((line)=>{
            // console.log(id);
            // console.log(line);
            let listaPuntos = line.vertices;
            /* console.log(listaPuntos); */
            if(line.rectangulosLinea.includes(id)){
                if(line.rectangulosLinea[0]===id){
                    // console.log('posicion 1');
                    listaPuntos[0] = e.target.attrs.x+width/2;
                    listaPuntos[1] = e.target.attrs.y+height/2;
                }else{
                    // console.log('posicion 2');
                    listaPuntos[2] = e.target.attrs.x+width/2;
                    listaPuntos[3] = e.target.attrs.y+height/2;
                }
                // console.log('lo contiene')
            }
            // console.log(line.vertices[0]);
        })
    }

    const handleTransform = (e) => {
        
        // transformer is changing scale of the node
        // and NOT its width or height
        // but in the store we have only width and height
        // to match the data better we will reset scale on transform end
        const id = e.target.attrs.id;
        const node = shapeRef.current;
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();
        // we will reset it back
        node.scaleX(1);
        node.scaleY(1);
        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height()* scaleY),
        });
    }

    
    const handleEditText = () =>{
        if(isSelected){
            setIsEditing(true);
        }else{
            setIsEditing(false);
        }
    } 
    

    return (
        <>  
            <Rect
                id={id}
                x={x}
                y={y}
                ref={shapeRef}
        
                width={width}
                height={height}
                draggable
                fill={fill}
                strokeWidth={0.1}
                stroke={contorno}

                onClick={onSelect}
                onTap={onSelect}

                onTransformEnd={handleTransform}
                onDragStart={handleDragStart}
                onDragEnd={handleDragEnd}
                //Evento para mover el 
                //nodo y que se muevan las lineas
                onDragMove={handleMove}
                
            />
            {isEditing ? 
            (
                <TextoEditable
                    id={id}
                    x={x}
                    y={y}
                    text={text}
                    nodos={nodos}
                    setNodos={setNodos}
                    setIsEditing={setIsEditing}
                    width={width}
                    height={height}
                    fontSize={fontSize}
                />                
            )
            :
            (
                <Text
                    id={id}
                    x={x}
                    y={y}
                    text={text}
                    /* ref={shapeRef} */

                    draggable
                    strokeWidth={10}
                    width={width}
                    height={height}
                    fontSize={fontSize}
                    fill={textFill}
                    align={align}
                    fontStyle={fontStyle}
                    verticalAlign={verticalAlign}
                    // Descomentar para usar las 
                    // propiedades del texto
                    /* {...shapeProps} */
                    
                    
                    onClick={onSelect}
                    onTap={onSelect}

                    onContextMenu={()=>{console.log('Click derecho')}}

                    onDblClick={handleEditText}

                    onDragStart={handleDragStart}
                    onDragEnd={handleDragEnd}
                    //Evento para mover el 
                    //nodo y que se muevan las lineas
                    onDragMove={handleMove}

                    
                />
            )}
            

            {isSelected ? 
                (
                    <AgregarNodo
                        id={id}
                        x={x}
                        y={y}
                        width={width}
                        height={height}
                        radius={10}
                        fill={fill}
                        setNodos={setNodos}
                        nodos={nodos}
                        lineas={lineas}
                        setLineas={setLineas}

                        historial={historial}
                        setHistorial={setHistorial}
                        historyStep={historyStep}
                        setHistoryStep={setHistoryStep}
                    />
                )
                :
                (null)
            }       
            
            {isSelected && !isEditing && (
                <>
                    <PanelHerramientas
                        id={id}
                        x={x}
                        y={y}
                        width={width}
                        height={height}
                        abrirModal={abrirModal}
                        setAbrirModal={setAbrirModal}
                        trRef={trRef}
                        nodos={nodos}
                        setNodos={setNodos}
                        lineas={lineas}
                        setLineas={setLineas}
                        mostrarImagen={mostrarImagen}
                        setMostrarImagen={setMostrarImagen}
                        isSelected={isSelected}
                        textFill={textFill}
                        fill={fill}
                        align={align}
                        tieneImagen={tieneImagen}
                    />
                </>
            )}
            
            
        </>
    )
}

export default NodoComponent;